/**
 *
 * Skeleton
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { StyledSkeleton } from './Skeleton.styles';

export const ANIMATIONS = Object.freeze({
  PULSE: 'pulse',
  WAVE: 'wave',
  NO_ANIMATON: false,
});

export const VARIANTS = Object.freeze({
  CIRCULAR: 'circular',
  RECTANGULAR: 'rectangular',
  ROUNDED: 'rounded',
  TEXT: 'text',
});

const Skeleton = ({ widthFrom, widthTo, ...props }) => {
  let { width } = props;

  if (widthFrom && widthTo) {
    width = widthFrom + Math.floor(Math.random() * (widthTo - widthFrom));
  }

  return <StyledSkeleton {...props} width={width} />;
};

Skeleton.propTypes = {
  animation: PropTypes.oneOf([...Object.values(ANIMATIONS)]),
  height: PropTypes.number,
  variant: PropTypes.oneOf([...Object.values(VARIANTS)]),
  width: PropTypes.number,
  widthFrom: PropTypes.number,
  widthTo: PropTypes.number,
};

export default memo(Skeleton);
